var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-h6 text-md-h5",class:{ 'text-md-center': _vm.center, 'pb-2': !_vm.wave }},[_c('strong',[_vm._t("default")],2)]),(_vm.wave)?_c('small-wave',{staticClass:"py-2",attrs:{"center":_vm.center}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }